import { DataGridLayout, List, ListHeader, ListPageLayout, SearchInput } from 'framework/list';
import { CustomBadge } from 'framework/ui/ui-builder';
import { useAuthorization } from 'framework/authorization';
import EditVacancyPublicationButton from 'domain/recruiting/vacancy/publication/shared/button/EditVacancyPublicationButton';
import { useVacancyUrl } from 'domain/recruiting/vacancy/vacancyRoute';
import useVacancyPublicationService, {
  PUBLISH_VACANCY,
} from 'domain/recruiting/vacancy/publication/shared/vacancyPublicationService';
import VacancyPublicationLinkField from 'domain/recruiting/vacancy/publication/shared/field/VacancyPublicationLinkField';
import { BadgeField, SearchLinkField, SearchResultField } from 'framework/ui/field';
import VacancyStatusField from 'domain/recruiting/vacancy/shared/field/VacancyStatusField';

const VacancyPublicationList = () => {
  const { search } = useVacancyPublicationService();
  const { getSingleEntityUrl: getVacancyUrl } = useVacancyUrl();
  const { isGranted } = useAuthorization();

  return (
    <List getDataMethod={search} defaultSortOrder="DESC" defaultSortField="updatedAt">
      <ListPageLayout
        header={<ListHeader label="Vacancy Publications" icon="fa-ship" />}
        search={<SearchInput label="vacancy name or ID" />}
      >
        <DataGridLayout
          buttons={[
            <EditVacancyPublicationButton
              key="edit-vacancy-publication"
              source="id"
              outline
              isVisible={vacancy => {
                return isGranted(PUBLISH_VACANCY) || vacancy.status !== 'OPEN';
              }}
              permissionToCheck=""
            />,
          ]}
        >
          <VacancyPublicationLinkField source="id" label="ID" nameSource="id" />
          <SearchLinkField
            source="vacancy.alias"
            url={(id?: Nullable<StringOrNumber>) => getVacancyUrl(id)}
            value=""
            label="Vacancy ID"
          />
          <SearchResultField source="name" isSortable />
          <VacancyStatusField source="status" label="Status" isSortable />
          <BadgeField
            badges={[<CustomBadge id="draftVacancy" text="SYCOM" />]}
            label="Publication platform"
            source="name"
            isSortable
          />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default VacancyPublicationList;
